import { ArdoqId } from '@ardoq/api-types';
import { useEffect, useState } from 'react';
import { HighlightState, HighlightedBy } from './types';

const nothingHighlighted: HighlightState = {
  highlightedComponentId: null,
  highlightedBy: 'none',
};

export const useHighlightState = (selectedComponentId: ArdoqId | null) => {
  const [
    { highlightedComponentId, highlightedBy },
    setComponentHighlightState,
  ] = useState<HighlightState>(nothingHighlighted);
  const [highlightedReferenceId, setHighlightedReferenceId] =
    useState<ArdoqId | null>(null);

  const highlightComponent = (
    componentId: ArdoqId | null,
    currentHighlightedBy: HighlightedBy
  ) => {
    const stateNotChanged =
      componentId === highlightedComponentId &&
      highlightedBy === currentHighlightedBy;
    const hoverOnComponentWhileSomeClicked =
      highlightedBy === 'click' && currentHighlightedBy === 'hover';

    if (hoverOnComponentWhileSomeClicked || stateNotChanged) {
      return;
    }

    if (currentHighlightedBy === 'click') {
      setHighlightedReferenceId(null);
    }

    if (!componentId || currentHighlightedBy === 'none') {
      setComponentHighlightState(nothingHighlighted);
    } else {
      setComponentHighlightState({
        highlightedComponentId: componentId,
        highlightedBy: currentHighlightedBy,
      });
    }
  };

  const highlightReference = (referenceId: ArdoqId | null) => {
    if (referenceId === highlightedReferenceId) {
      setHighlightedReferenceId(null);
      return;
    }

    setHighlightedReferenceId(referenceId);
    setComponentHighlightState(nothingHighlighted);
  };

  const onCancelHighlight = () => {
    setComponentHighlightState(nothingHighlighted);
    setHighlightedReferenceId(null);
  };

  useEffect(() => {
    onCancelHighlight();
  }, [selectedComponentId]);

  return {
    highlightedComponentId,
    highlightedReferenceId,
    highlightedBy,
    highlightComponent,
    highlightReference,
    onCancelHighlight,
  };
};
